import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";
import useStore from "../../store/useStore";
import SessionHabitatTabs from "./HabitatTabs";
import SessionManagementPractices from "./ManagementPractices";
import SessionSatisfactionList from "./SatisfactionList";
import { useSearchParams } from "react-router-dom";

interface SessionInfoTabsTabsProps {
  label: string;
  component: ReactNode;
}
type SessionInfoTabsTabs = Record<string, SessionInfoTabsTabsProps>;

const tabs: SessionInfoTabsTabs = {
  habitatTabs: {
    label: "Formulaires Habitats",
    component: <SessionHabitatTabs />,
  },
  satisfaction: {
    label: "Satisfaction",
    component: <SessionSatisfactionList />,
  },
  managementPractices: {
    label: "Pratiques de gestion",
    component: <SessionManagementPractices />,
  },
};

const SessionInfoTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabsRef = useRef(null);
  let tabKeys = Object.keys(tabs);
  const { session } = useStore((state) => state);

  if (!session?.form.satisfaction) {
    tabKeys = tabKeys.filter((key) => key !== "satisfaction");
  }

  if (!session?.site.habitats || !session?.site.habitats.length) {
    tabKeys = tabKeys.filter((key) => !["habitatTabs"].includes(key));
  }

  const defaultTab = tabKeys[0];
  const [value, setValue] = useState<string>(defaultTab!);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (
      tabsRef.current &&
      searchParams.get("form") &&
      searchParams.get("form") === "management-practices"
    ) {
      setValue("managementPractices");
      (tabsRef.current as HTMLElement).scrollIntoView();
    }
  }, [searchParams]);

  return (
    <TabContext value={value}>
      <Box ref={tabsRef} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList onChange={handleChange} aria-label="session info tabs">
          {tabKeys.map((key) => (
            <Tab key={key} label={tabs[key].label} value={key} />
          ))}
        </TabList>
      </Box>
      {tabKeys.map((key) => (
        <TabPanel key={key} value={key} sx={{ p: 1 }}>
          {tabs[key].component}
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default SessionInfoTabs;
